"use client"

import { VStack } from "@chakra-ui/react"

import PageSkeleton from "@/components/PageSkeleton"
import Footer from "@/sections/Footer"
import SectionHero from "@/sections/Work/HeroWorkSection"
import MyArticles from "@/sections/Work/MyArticles"
import { Category, Skill, WebpageConfig } from "@/types/database"
import { Post } from "@/types/database"

interface WorkProps {
  posts: Post[]
  currentPage: number
  itemsPerPage: number
  totalItems: number
  totalPages: number
  webpage_config: WebpageConfig
  allTags?: Skill[]
  allCategories?: Category[]
  initialSelectedCategories?: string[]
  initialSelectedTags?: string[]
  initialSorting?: string
}

const Work = ({
  allCategories,
  allTags,
  currentPage,
  initialSelectedCategories,
  initialSelectedTags,
  initialSorting,
  itemsPerPage,
  posts,
  totalPages,
  webpage_config,
}: WorkProps) => {
  return (
    <PageSkeleton name="work">
      <VStack
        alignItems="center"
        bgColor={"bg.paper"}
        gap={0}
        justifyContent={"flex-start"}
        width={"full"}
      >
        <VStack
          alignItems="center"
          className="work"
          gap={0}
          minHeight={"calc(100vh - 104px)"}
          rounded={"0"}
          width={"full"}
        >
          <SectionHero
            heading={"Case Studies"}
            preface={"Work"}
            rightImg={`${webpage_config?.case_study_hero_img?.id}`}
            subHeading={webpage_config?.case_study_welcome_msg}
          />

          <MyArticles
            allCategories={allCategories ?? []}
            allTags={allTags ?? []}
            articlePathPrefix="/case-study"
            currentPage={currentPage}
            heading="My Articles 🗞️"
            hideCategories
            initialSelectedCategories={initialSelectedCategories}
            initialSelectedTags={initialSelectedTags}
            initialSorting={initialSorting}
            itemsPerPage={itemsPerPage}
            postCardName="card11"
            posts={posts}
            totalPages={totalPages ?? 1}
            totalPosts={posts.length}
          />

          {/* <LetsTalk2 /> */}
          <Footer />
        </VStack>
      </VStack>
    </PageSkeleton>
  )
}

export default Work
